<script>
export default {
  props: {
    back: { type: Boolean, default: true }, //是否显示返回
    paths: { type: Array, required: true, default: () => [] }, //导航路径
    scroll: { type: Boolean, default: false }
  }
}
</script>

<template>
  <div class="crumb-layout">
    <!--面包屑区域-->
    <crumb :paths="paths" :back="back">
      <template #extra>
        <slot name="extra"></slot>
      </template>
    </crumb>

    <!--页面内容区域-->
    <div class="crumb-layout-wrapper" :class="[scroll ? 'scroll' : '']">
      <div class="crumb-layout-wrapper-container">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.crumb-layout{
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  .crumb{
    margin-bottom: 15px;
  }

  &-wrapper{
    flex: 1;
    position: relative;
    background-color: #fff;

    &-container{
      position: absolute;
      left: 10px;
      top: 10px;
      right: 10px;
      bottom: 10px;
    }

    &.scroll{
      overflow-x: hidden;
      overflow-y: auto;

      .crumb-layout-wrapper-container{
        position: relative;
        left: auto;
        right: auto;
        top: auto;
        bottom: auto;
      }
    }
  }
}
</style>
